var likeDesigns = (function() {
  jQuery.ajaxSettings.traditional = true;

  var _designCountsMap = {};
  var _designIds = ['0'];
  var _likeCounts = {};
  var _userId = null;
  var _withCount = false;
  var likesApiBaseUrl = 'https://apps.joltteam.com';
  var refreshLikesApiPath = '/internal/like-designs/filterLikedDesigns';

  function joltApiRequest(options) {
    if (options.beforeSend) {
      throw new Error('Use `$.ajax` directly for custom `beforeSend` behaviors.');
    }
    options.beforeSend = function(_, options) {
      options.url = likesApiBaseUrl + options.url;
    };
    return $.ajax(options);
  }

  function initalizeAndRefreshLikes(userId, designsIds, withCount, defaultState) {
    initializeLikes(userId, designsIds, withCount, defaultState);
    refresh();
  }

  function initializeLikes(userId, designsIds, withCount, defaultState) {
    _userId = (userId && userId.length > 0) ? 'bu_' + userId : '0';
    _designIds = _designIds.concat(designsIds);
    for(var i = 0; i < _designIds.length; i++) {
      _designCountsMap[_designIds[i]] = 0;
    }
    _withCount = withCount;
  }

  function refresh() {
    if (_withCount) {
      return refreshCounts(_designIds);
    }
    return refreshLikes();
  }

  function refreshLikes() {
    var request = joltApiRequest({
      url: refreshLikesApiPath,
      type: 'POST',
      data: {userId: _userId , designIds: _designIds},
    });

    request.done(function(likedDesigns) {
      var notLikedDesigns = _designIds.filter(function(designId) {
        return (likedDesigns.indexOf(designId) === -1);
      });
      setLiked(likedDesigns);
      setNotLiked(notLikedDesigns);
    });

    request.fail(function(jqXHR, textStatus) {
      console.log('Error from server, httpStatus:' + jqXHR.status + ' message:' +
        jqXHR.responseText + ';' + textStatus);
    });
  }

  function refreshCounts() {
    for(var i = 0; i < _designIds.length; i++) {
      designId = _designIds[i];
      if (designId === '0') {
        continue;
      }
      var apiPath = constructLikeCountResourceURI(designId, _userId);
      var request = joltApiRequest({
        url: apiPath,
        type: 'GET',
      });

      request.done(function(result) {
        setLikeCount(result.design_id, result.likes);
        if (result.user_liked) {
          return setLiked(result.design_id);
        }
        return setNotLiked(result.design_id);
      });

      request.fail(function(jqXHR, textStatus) {
        console.log('Error from server, httpStatus:' + jqXHR.status +
          ' message:' + jqXHR.responseText + ';' + textStatus);
      });
    }
  }

  function like(designId) {
    if (!_userId || _userId === '0') {
      return showLoginPopup();
    }
    var apiPath = constructLikeResourceURI(designId, _userId);
    setLiked(designId);
    setLikeCount(designId, _designCountsMap[designId] + 1);
    var request = joltApiRequest({
      url: apiPath,
      type: 'PUT',
    });

    request.fail(function(jqXHR, textStatus) {
      console.log('Error from server, httpStatus:' + jqXHR.status + ' message:' +
        jqXHR.responseText + ';' + textStatus);
      setNotLiked(designId);
      setLikeCount(designId, _designCountsMap[designId] - 1);
    });

    return false;
  }

  function unlike(designId) {
    if (_userId === '0') {
      return showLoginPopup();
    }
    var apiPath = constructLikeResourceURI(designId, _userId);
    setNotLiked(designId);
    setLikeCount(designId, _designCountsMap[designId] - 1);
    var request = joltApiRequest({
      url: apiPath,
      type: 'DELETE',
    });

    request.fail(function(jqXHR, textStatus) {
      console.log('Error from server, httpStatus:' + jqXHR.status + ' message:' +
        jqXHR.responseText + ';' + textStatus);
      setLiked(designId);
      setLikeCount(designId, _designCountsMap[designId] + 1);
    });

    return false;
  }

  function constructLikeResourceURI(designId, userId) {
    return '/internal/like-designs/design/' + designId + '/likes/' + userId;
  }

  function constructLikeCountResourceURI(designId, userId) {
    return '/internal/like-designs/design/' + designId + '/user/' + userId;
  }

  function setLiked(likeDesignIds) {
    if (!Array.isArray(likeDesignIds)) {
      likeDesignIds = [likeDesignIds];
    }
    if (likeDesignIds && likeDesignIds.length > 0) {
      for(var i = 0; i < likeDesignIds.length; i++) {
        var likeDesignId = likeDesignIds[i];
        $('#like-' + likeDesignId)
          .removeClass('brikbuild-not-liked')
          .addClass('brikbuild-liked');
        $('#like-button-' + likeDesignId)
          .off('click')
          .on('click', function() { unlike($(this).data('articleId')); });
      }
    }
  }

  function setNotLiked(likeDesignIds) {
    if (!Array.isArray(likeDesignIds)) {
      likeDesignIds = [likeDesignIds];
    }
    if (likeDesignIds && likeDesignIds.length > 0) {
      for(var i = 0; i < likeDesignIds.length; i++) {
        var likeDesignId = likeDesignIds[i];
        $('#like-' + likeDesignId)
          .removeClass('brikbuild-liked')
          .addClass('brikbuild-not-liked');
        $('#like-button-' + likeDesignId)
          .off('click')
          .on('click', function() { like($(this).data('articleId')); });
      }
    }
  }

  function setLikeCount(likeDesignId, count) {
    _designCountsMap[likeDesignId] = count;
    if (likeDesignId && likeDesignId !== '0') {
      var text = count + ((count == 1) ? ' like' : ' likes');
      $('#like-count-' + likeDesignId).text(text);
    }
  }

  function getUserLikedDesigns(userId, page, limit, callback) {
    if (_userId === '0') {
      return showLoginPopup();
    }

    var request = joltApiRequest({
      url: '/internal/like-designs/user/' + userId + '/likedDesigns/page/' + page
        + '/limit/' + limit,
      type: 'GET',
    });

    request.done(function(result) {
      callback(null, result);
    });

    request.fail(function(jqXHR, textStatus) {
      console.log('Error from server, httpStatus:' + jqXHR.status + ' message:' +
        jqXHR.responseText + ';' + textStatus);
      callback({status : jqXHR.status, message : jqXHR.responseText});
    });
  }

  function showLoginPopup() {
    var redirect = window.confirm(
      'You must be logged in to like a design. Continue?'
    );
    if (!redirect) {
      return false;
    }
    window.location.href = '/account/login?next=' + window.location.pathname;
  }

  function setAllLiked() {
    setLiked(_designIds);
  }

  return {
    getUserLikedDesigns: getUserLikedDesigns,
    initalizeAndRefreshLikes: initalizeAndRefreshLikes,
    initializeLikes: initializeLikes,
    setAllLiked: setAllLiked,
  };
}());
var initalizeAndRefreshLikes = likeDesigns.initalizeAndRefreshLikes;
var initializeLikes = likeDesigns.initializeLikes;
var getUserLikedDesigns = likeDesigns.getUserLikedDesigns;
var setAllLiked = likeDesigns.setAllLiked;
